import React, { useState } from "react";
import styles from './OrderVisibility.module.css';
import SingleBarChart from "Samarth Module/components/Charts/SingleBarchart";
import ExpandedModal from "Samarth Module/components/modal/ExpandedModal";
import ArrowsOut from './../../../../assets/images/ArrowsOut.svg';
import ToggleButton from "Samarth Module/components/ToggleButton/ToggleButton";
import CustomerBucketCountGraph from "./CustomerBucketCountGraph";

const DCSuggestedOrders = ({ label, graphData, customerBucketCount, sideTab }) => {
    const [selectedView, setSelectedView] = useState('Customer Bucket Count');
    const [expandedView, setExpandedView] = useState(false);

    // Handler for view change
    const handleViewChange = (selected) => {
        setSelectedView(selected);
    };
    // Handler for expanding the graph
    const handleExpand = () => {
        setExpandedView(prev => !prev);
    }
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p className={styles.title}>{selectedView}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <ToggleButton
                        options={['Customer Bucket Count', 'DC wise suggested orders']}
                        defaultSelected={selectedView}
                        onChange={handleViewChange}
                    />
                    <div className={styles.arrows_out}>
                    <img src={ArrowsOut} alt='Simple Bar Chart' height={16} width={16} onClick={handleExpand} />
                    </div>
                </div>
            </div>
            <div style={{
                height: selectedView !== 'Customer Bucket Count' ? '300px' : '100%',
                overflowX: 'hidden'
            }}>
                {selectedView === 'Customer Bucket Count' ? (
                    <CustomerBucketCountGraph graphData={customerBucketCount} sideTab={sideTab} />
                ) : (
                    <SingleBarChart graphData={graphData} sideTab={sideTab} />
                )}
            </div>
            {expandedView && (
                <ExpandedModal onClose={handleExpand} open={expandedView} >
                    <div className={styles.modalContainer}>
                        <p className={styles.title}>{selectedView}</p>
                        <div>
                            {selectedView === 'Customer Bucket Count' ? (
                                <CustomerBucketCountGraph graphData={customerBucketCount} sideTab={sideTab} />
                            ) : (
                                <SingleBarChart graphData={graphData} sideTab={sideTab} />
                            )}
                        </div>
                    </div>
                </ExpandedModal>
            )}
        </>
    )
};

export default DCSuggestedOrders;